// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__dPx7m","content":"styles_content__1Q1as","checkbox":"styles_checkbox__2CIgr","checkboxLabel":"styles_checkboxLabel__WYp_8"};